import { MDialogComponent } from './../../../components/m-dialog/m-dialog.component';
import { UtilConfigAnalytics } from './../../../utils/configuracoes/util-config-analytics';
import { GoogleAnalyticsService } from './../../../analytics/google-analytics.service';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MSolicitarRelatorioAnaliticComponent } from '../../m-solicitar-relatorio-analitic/m-solicitar-relatorio-analitic.component';
import { MSolicitarRelAnaliticoService } from '../../m-solicitar-relatorio-analitic/solicitar-rel-analitico.service';

@Component({
  selector: 'app-cards-footer',
  templateUrl: './cards-footer.component.html',
  styleUrls: ['./cards-footer.component.scss'],
})
export class CardsFooterComponent {

  public loadModalRelAnalitico: boolean = false;
  constructor(
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    public dialog: MatDialog,
    private readonly service: MSolicitarRelAnaliticoService,

  ) { }

  // abrirModalSolicitarRelAnalitico() {
  //   this.googleAnalyticsService.pushTag(UtilConfigAnalytics.ConfigAnalytics('card-solicitar-relatorio-analitico', 'Outras informações de dados'));
  //   this.loadModalRelAnalitico = true;
  //   if (this.modalRelatorioAnalitico !== undefined) {
  //     this.modalRelatorioAnalitico.openNewModal();
  //     return true
  //   } else {
  //     return false
  //   }
  // }

  irPara(rota: any, local: any = null, texto: any = null, numero: number = 0): void {


    this.googleAnalyticsService.pushTag(UtilConfigAnalytics.ConfigAnalyticsCard('select-content-ga4', 'serasainstitucional_web_card_meio_' + numero, 'card', texto, 'serasa-institucional', 'lgpd-conheca-seus-direitos', 'logado', null, 'clique-card'));
    this.googleAnalyticsService.pushTag(UtilConfigAnalytics.ConfigAnalyticsCard('select-content', null, null, null, 'serasa-institucional', 'lgpd-conheca-seus-direitos', 'logado', 'serasa-institucional-lgpd', 'clique-card', texto));
    window.location.href = rota;
  }

  private montaDados(res) {
    return {
      datacriacaoprotocolo: res.orders[0].dtCreate ? new Date(res.orders[0].dtCreate.toString()) : null,
      protocolo: res.orders[0].protocol ? res.orders[0].protocol : null,
      status: res.orders[0].status ? res.orders[0].status.toLocaleUpperCase() : null,
      dataInicio: res.orders[0].dtStart ? new Date(res.orders[0].dtStart) : null,
      dataFim: res.orders[0].dtEnd ? new Date(res.orders[0].dtEnd) : null,
    };
  }


  private montaDadosDialogPedidoExistente(data) {
    return {
      width: '60vw',
      data: {
        titulo: "Aviso",
        mensagem: `Sua solicitação ${data.protocolo} criada em ${data.datacriacaoprotocolo.toLocaleDateString()} está em andamento.
                 Por favor, aguarde a finalização do prazo e consulte novamente.`,
        action: true
      }
    }
  }

  openDialog(): void {

    let isAbleToRequestNewRelAnalitico: boolean | null = null

    this.service.retrievePedido().subscribe(
      (res) => {
        if (res != null && res.orders != null) {
          res.orders = res.orders.sort((val1: any, val2: any) => { return Date.parse(val2.dtCreate) - Date.parse(val1.dtCreate) });
          const data = this.montaDados(res)
          if (data.status !== 'FINALIZADO') {
            isAbleToRequestNewRelAnalitico = false;
            this.dialog.open(MDialogComponent, this.montaDadosDialogPedidoExistente(data));
          } else {
            isAbleToRequestNewRelAnalitico = true;
            this.dialog.open(MSolicitarRelatorioAnaliticComponent, {
              data: {
                isAbleToRequestNewRelAnalitico,
                data
              }
            });
          }
        }
      },
      (err) => {
        isAbleToRequestNewRelAnalitico = true;
        this.dialog.open(MSolicitarRelatorioAnaliticComponent, {
          data: {
            isAbleToRequestNewRelAnalitico
          }
        });
      });
  }
}
